// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';


function fromJs(str) {
  switch (str) {
    case "description" :
      return "description";
    case "keyFacts" :
      return "keyFacts";
    case "mlsTiming" :
      return "mlsTiming";
    case "photosAndFiles" :
      return "photosAndFiles";
    case "showings" :
      return "showings";
    default:
      return;
  }
}

function toJs(t) {
  return t;
}

let Key = {
  fromJs: fromJs,
  toJs: toJs
};

let Step = {};

exports.Key = Key;
exports.Step = Step;
/* No side effect */
